import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { AppActions, AppActionTypes } from './actions';
import { CropVarietySpecificNorm, CropVarietySpecificNormState } from '../shared/models';

export const cropVarietySpecificNormAdapter: EntityAdapter<CropVarietySpecificNorm> = createEntityAdapter<CropVarietySpecificNorm>();
export const initialCropVarietySpecificNormState: CropVarietySpecificNormState = cropVarietySpecificNormAdapter.getInitialState({});

export function cropVarietySpecificNormReducer(state = initialCropVarietySpecificNormState, action: AppActions): CropVarietySpecificNormState {
  switch (action.type) {
    case AppActionTypes.LoadCropVarietySpecificNormsSuccess: {
      const removedState = cropVarietySpecificNormAdapter.removeAll(state);
      return cropVarietySpecificNormAdapter.upsertMany(action.cropVarietySpecificNorms, removedState);
    }

    case AppActionTypes.UpsertCropVarietySpecificNormSuccess: {
      return cropVarietySpecificNormAdapter.upsertOne(action.cropVarietySpecificNorm, state);
    }

    case AppActionTypes.DeleteCropVarietySpecificNormSuccess: {
      return cropVarietySpecificNormAdapter.removeOne(action.cropVarietySpecificNorm.id, state);
    }

    default: {
      return state;
    }
  }
}
